/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class User {
        public token: string;
        public userId: string;
        public userName: string;
        public emailAddress: string;
        public firstName: string;
        public lastName: string;
        public imageUrl: string;
        public expires: Date; 
    }
}